import React from "react";
import ApiInformationPage from 'models/data/api/ApiInformationPage'
import InformationPageQuery from './InformationPageQuery'
import styled from 'styled-components'
import { FooterWithState } from "components/Footer";

const InformationPageContainer = styled.div`
	font-family: ${props => props.theme.fonts.poppins};

	h3 {
		font-size: 1.5rem;
		padding: 20px 0;
	}

    p {
        padding: 10px 0;
    }

	a {
		color: ${props => props.theme.colors.orange};
		text-decoration: underline;
	}
`;

export default ({ page }) => (
  <InformationPageQuery page={page}>
    {({ informationPage }) => (
      <>
        <InformationPageContainer className="lg:px-64 md:px-32 sm:px-16 px-4 pb-20">
          <h1 className="text-3xl pb-4">
            {ApiInformationPage.title(informationPage)}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: ApiInformationPage.bodyHtml(informationPage)
            }}
          />
        </InformationPageContainer>
        <FooterWithState />
      </>
    )}
  </InformationPageQuery>
);